import { useEffect, useRef, useState } from 'react';
import { Keyboard, TextInput } from 'react-native';
import {
  Colors,
  Flex,
  PrimaryButton,
  Typography,
  useBottomSheetEntered,
} from '@banhala/ui-kit';
import { bridge, delay, isWeb } from 'shared/src/utils';

interface FolderNameEditorProps {
  initialValue: string;
  validate: (value: string) => boolean;
  onSubmit: (value: string) => Promise<void>;
  onClose: () => void;
}

export const FolderNameEditor = ({
  initialValue,
  validate,
  onSubmit,
  onClose,
}: FolderNameEditorProps) => {
  const [value, setValue] = useState(initialValue);
  const ref = useRef<TextInput>(null);
  // 바텀시트 진입 애니메이션 종료 후 포커스 → Android translucent react-modal
  // 액티비티에서 autoFocus가 윈도우 포커스 전에 발사돼 키보드가 안 뜨는 race 회피.
  const entered = useBottomSheetEntered();
  useEffect(() => {
    if (entered && !isWeb) ref.current?.focus();
  }, [entered]);

  const handleSubmit = async () => {
    Keyboard.dismiss();
    try {
      await onSubmit(value);
    } catch (error) {
      onClose();
      await delay(500);
      bridge.toast(
        error instanceof Error && error.message
          ? error.message
          : '오류가 발생했어요',
      );
    }
  };

  return (
    <>
      <Flex padding={{ horizontal: 16, vertical: 12 }}>
        <Flex
          borderWidth={1}
          borderColor={'border_blue_primary'}
          borderRadius={'small'}
          padding={{ horizontal: 12, vertical: 15 }}
        >
          <TextInput
            ref={ref}
            defaultValue={initialValue}
            style={{
              fontSize: 15,
              color: Colors.content_primary,
              padding: 0,
              outlineWidth: 0,
            }}
            placeholder="서랍 이름은 최소 한 글자 이상 입력해주세요"
            placeholderTextColor={Colors.content_tertiary}
            multiline
            onChangeText={setValue}
            maxLength={30}
          />
          <Flex.Row justifyContent={'flex-end'} padding={{ top: 16 }}>
            <Typography type={'body3'} color={'content_primary'}>
              {value.length}
            </Typography>
            <Typography type={'body3'} color={'content_tertiary'}>
              {' / 30'}
            </Typography>
          </Flex.Row>
        </Flex>
      </Flex>
      <Flex padding={{ horizontal: 12, vertical: 12 }}>
        <PrimaryButton
          variant={'fill'}
          color={'pink'}
          size={'xlarge'}
          state={validate(value) ? undefined : 'disabled'}
          onPress={handleSubmit}
        >
          완료
        </PrimaryButton>
      </Flex>
    </>
  );
};
